import {
    StepVariables,
    ToolContext
} from "@omni/types/components/tracking/tracking-info/tools/toolStep.trackingInfo";

type StepTypes = "start" | "submit";

const TOOL_NEWSLETTER_STEPS: Record<StepTypes, StepVariables> = {
    start: {
        stepName: "hubo nieuwsbrief",
        stepNumber: 1,
        placement: "promoties:nieuwsbrief",
        result: {},
        option: ""
    },
    submit: {
        stepName: "ingeschreven",
        stepNumber: 2,
        placement: "promoties:nieuwsbrief",
        result: {}, //customerId + store
        option: ""
    }
};

const TOOL_NEWSLETTER_CONTEXT: Readonly<ToolContext> = {
    name: "newsletter",
    type: "form"
};

export { TOOL_NEWSLETTER_CONTEXT, TOOL_NEWSLETTER_STEPS };
